import { ReactNode } from "react";

// One card on the home page: same shell everywhere so the grid lines up on
// a phone and a desktop alike.
const DashCard = ({
  title,
  aside,
  className = "",
  children,
}: {
  title: ReactNode;
  aside?: ReactNode;
  className?: string;
  children: ReactNode;
}) => (
  <div className={`card bg-base-100 shadow w-full min-w-0 ${className}`}>
    <div className="card-body p-3 sm:p-4 gap-3">
      <div className="flex items-center justify-between gap-2 flex-wrap">
        <h3 className="font-semibold text-lg flex items-center gap-2 min-w-0">
          {title}
        </h3>
        {aside}
      </div>
      {children}
    </div>
  </div>
);

export default DashCard;
